'use strict';

var BADGE_MAX = 99;

/**
 * Header badge label. Counts above 99 render as "99+".
 * @param {number|string} quantity - Basket quantity
 * @returns {string} Visible badge text, empty when the cart has no items
 */
function formatMinicartBadgeCount(quantity) {
    var qty = Number(quantity);

    if (!Number.isFinite(qty) || qty <= 0) {
        return '';
    }

    if (qty > BADGE_MAX) {
        return BADGE_MAX + '+';
    }

    return String(Math.floor(qty));
}

/**
 * Write the header badge and the drawer count.
 * The drawer keeps the real quantity; only the icon badge is capped.
 * @param {number|string} quantity - Basket quantity
 */
function setMinicartQuantity(quantity) {
    var badge = formatMinicartBadgeCount(quantity);
    var drawerQty = Number(quantity);

    $('.minicart .minicart-quantity')
        .text(badge)
        .toggleClass('minicart-quantity--cap', badge.indexOf('+') !== -1);

    $('.js-minicart-drawer .minicart-quantity').text(
        Number.isFinite(drawerQty) ? String(Math.max(0, Math.floor(drawerQty))) : ''
    );
}

module.exports = {
    formatMinicartBadgeCount: formatMinicartBadgeCount,
    setMinicartQuantity: setMinicartQuantity
};
